<template>
  <svg id="laptop-closeup" width="100" height="200">
    <g class="monitor">
      <path fill="none" stroke="#2D2D2D" stroke-width="2" d="
              M 40,-5 L 40,80 105,80"
            />
      <path fill="none" stroke="#2D2D2D" stroke-width="2" class="screen" d="M 105,60 L 55,60 55,-5 105,-5 105,60"/>
    </g>
    <g class="body">
      <path fill="none" stroke="#2D2D2D" stroke-width="2" d="M 40,80 L 5,180 5,190 105,190 105,180 5,180"/>
      <g class="keys row-1">
        <path fill="none" stroke="#2D2D2D" stroke-width="2" d="M 50,90 L 60,90 57,100 47,100 50,90"/>
        <path fill="none" stroke="#2D2D2D" stroke-width="2" d="M 65,90 L 75,90 72,100 62,100 65,90"/>
        <path fill="none" stroke="#2D2D2D" stroke-width="2" d="M 80,90 L 90,90 87,100 77,100 80,90"/>
        <path fill="none" stroke="#2D2D2D" stroke-width="2" d="M 95,90 L 105,90 102,100 92,100 95,90"/>
      </g>
      <g class="keys row-2">
        <path fill="none" stroke="#2D2D2D" stroke-width="2" d="M 45,105 L 55,105 52,115 42,115 45,105"/>
        <path fill="none" stroke="#2D2D2D" stroke-width="2" d="M 60,105 L 70,105 67,115 57,115 60,105"/>
        <path fill="none" stroke="#2D2D2D" stroke-width="2" d="M 75,105 L 85,105 82,115 72,115 75,105"/>
        <path fill="none" stroke="#2D2D2D" stroke-width="2" d="M 90,105 L 100,105 97,115 87,115 90,105"/>
      </g>
      <g class="keys row-3">
        <path fill="none" stroke="#2D2D2D" stroke-width="2" d="M 40,120 L 50,120 47,130 37,130 40,120"/>
        <path fill="none" stroke="#2D2D2D" stroke-width="2" d="M 55,120 L 65,120 62,130 52,130 55,120"/>
        <path fill="none" stroke="#2D2D2D" stroke-width="2" d="M 70,120 L 80,120 77,130 67,130 70,120"/>
        <path fill="none" stroke="#2D2D2D" stroke-width="2" d="M 85,120 L 95,120 92,130 82,130 85,120"/>
        <path fill="none" stroke="#2D2D2D" stroke-width="2" d="M 100,120 L 110,120 107,130 97,130 100,120"/>
      </g>
      <g class="keys row-4">
        <path fill="none" stroke="#2D2D2D" stroke-width="2" d="M 35,135 L 45,135 42,145 32,145 35,135"/>
        <path fill="none" stroke="#2D2D2D" stroke-width="2" d="M 50,135 L 60,135 57,145 47,145 50,135"/>
        <path fill="none" stroke="#2D2D2D" stroke-width="2" d="M 65,135 L 75,135 72,145 62,145 65,135"/>
        <path fill="none" stroke="#2D2D2D" stroke-width="2" d="M 80,135 L 90,135 87,145 77,145 80,135"/>
        <path fill="none" stroke="#2D2D2D" stroke-width="2" d="M 95,135 L 105,135 102,145 92,145 95,135"/>
      </g>
      <g class="touchpad">
        <path fill="none" stroke="#2D2D2D" stroke-width="2" d="M 80,155 L 105,155 105,175 75,175 80,155"/>
      </g>
      <path fill="none" stroke="#2D2D2D" stroke-width="2" d="M 40,75 L 105,75" class="hinge"/>
      <path fill="none" stroke="#2D2D2D" stroke-width="2" d="M 55,75 L 55,80" class="hinge"/>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'KeyboardSvg'
}
</script>

<style scoped>
#laptop-closeup {
  border: 2px solid #2D2D2D;
  background: #FFF;
}

@keyframes dim-yellow {
  0% {
    fill: transparent;
  }
  30% {
    fill: #F2BF5C;
  }
  70% {
    fill: #F2BF5C;
  }
  100% {
    fill: transparent;
  }
}

@keyframes dim-orange {
  0% {
    fill: transparent;
  }
  30% {
    fill: #FCAD0F;
  }
  70% {
    fill: #FCAD0F;
  }
  100% {
    fill: transparent;
  }
}

@keyframes dim-dark-orange {
  0% {
    fill: transparent;
  }
  30% {
    fill: #FC5E0F;
  }
  70% {
    fill: #FC5E0F;
  }
  100% {
    fill: transparent;
  }
}

@keyframes dim-red {
  0% {
    fill: transparent;
  }
  30% {
    fill: #FC330F;
  }
  70% {
    fill: #FC330F;
  }
  100% {
    fill: transparent;
  }
}

.animate .keys.row-1 path {
  animation: dim-yellow 4s ease;
  animation-delay: 0s;
  transition: fill 200ms ease;
}

.animate .keys.row-2 path {
  animation: dim-orange 4s ease;
  animation-delay: 0.5s;
  transition: fill 200ms ease;
}

.animate .keys.row-3 path {
  animation: dim-dark-orange 4s ease;
  animation-delay: 1s;
  transition: fill 200ms ease;
}

.animate .keys.row-4 path {
  animation: dim-red 4s ease;
  animation-delay: 1.5s;
  transition: fill 200ms ease;
}

.screen {
  transition: fill 200ms ease;
  fill: #2D2D2D;
}

.screen:hover {
  fill: #F2BF5C;
  transition: fill 200ms ease;
}
</style>
